import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutationAddGoogleMyBusiness } from '@adflow/frontend/feat-google-my-business';
import { useDispatchNavAction } from '@adflow/frontend/util-router';
import { CreateGMBTemplateValuesDto } from '@adflow/shared/data-google-my-business';

import { GMBTemplateFormView } from './GMBTemplateFormView';
import { goToEditGMBTemplate } from './GMBTemplateNavActions';

export function GMBTemplateFormAdd() {
	const { t } = useTranslation('facebook');

	const navigate = useDispatchNavAction();

	const defaultValues = useMemo(() => {
		return {
			id: -1,
			createdAt: new Date().toISOString(),
			updatedAt: new Date().toISOString(),
			imported: false,
			...CreateGMBTemplateValuesDto(),
		};
	}, []);

	const addTemplate = useMutationAddGoogleMyBusiness();

	return (
		<GMBTemplateFormView
			title={t('addTemplate')}
			template={defaultValues}
			onSubmit={async (values) => {
				const result = await addTemplate.mutateAsync(values);
				navigate(goToEditGMBTemplate(result.id));
			}}
		/>
	);
}
